// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-picker-popover .components-tab-panel__tab-content > * {
  padding: 0 16px;
}
.color-picker-popover .components-tab-panel__tab-content .components-circular-option-picker::before {
  content: "Themes";
  display: block;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  margin: 8px 0 6px;
  color: #1e1e1e;
}/*# sourceMappingURL=ColorPickerControl.css.map */`, "",{"version":3,"sources":["webpack://./src/components/ColorPickerControl/ColorPickerControl.scss","webpack://./src/components/ColorPickerControl/ColorPickerControl.css"],"names":[],"mappings":"AAEI;EACI,eAAA;ACDR;ADII;EACE,iBAAA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAAA;ACFR,CAAA,iDAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
